<template>
  <div>
    <v-dialog v-model="dialog.dialogBrowseOrderItem" max-width="800px" scrollable eager>
      <OrderItemBrowse ref="OrderItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </OrderItemBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseTestItem" max-width="800px" scrollable eager>
      <TestItemBrowse ref="TestItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </TestItemBrowse>
    </v-dialog>
    <v-toolbar scrollable color="light-blue darken-4" dark>
      <v-spacer></v-spacer>
      <v-btn ref = "buttonNew" color="primary" style="text-transform: capitalize" @click="newOrderItem" :disabled="disabledControl.buttonNew">
        <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('new')}}
      </v-btn>
      <v-btn ref = "buttonDelete" color="primary" style="text-transform: capitalize" @click="deleteOrderItem" :disabled="disabledControl.buttonDelete">
        <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('delete')}}
      </v-btn>
      <v-btn ref = "buttonSave" color="primary" style="text-transform: capitalize" @click="saveOrderItem" :disabled="disabledControl.buttonSave">
        <img src="../assets/SoftwareClinicIcon/Save.png" height="30" weight="30"/>{{$t('save')}}
      </v-btn>
      <v-btn ref = "buttonQuery" color="primary" style="text-transform: capitalize" @click="queryOrderItem" :disabled="disabledControl.buttonQuery">
        <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>{{$t('query')}}
      </v-btn>
      <v-btn ref = "buttonFind" color="primary" style="text-transform: capitalize" @click="findOrderItem" :disabled="disabledControl.buttonFind">
        <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
      </v-btn>
    </v-toolbar>
    <v-container grid-list-xs text-xs-center fluid>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Order Item ID" v-model="orderItemData.order_item_id" ref="textFieldOrderItemID" :readonly="readOnlyControl.textFieldOrderItemID" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Order Item Description" v-model="orderItemData.order_item_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu v-model="menu.menuEffectiveStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="orderItemData.eff_start_date" label="Effective Start Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="orderItemData.eff_start_date" @input="menu.menuEffectiveStartDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu v-model="menu.menuEffectiveStopDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="orderItemData.eff_stop_date" label="Effective Stop Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="orderItemData.eff_stop_date" @input="menu.menuEffectiveStopDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Order Item Alias ID" v-model="orderItemData.alias_id" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Order Item Alias Descrpition" v-model="orderItemData.alias_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="nickname" v-model="orderItemData.nickname" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Sequence" v-model="orderItemData.seq" type="number" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Additional Descrpition" v-model="orderItemData.additional_desc" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-textarea
                v-model="orderItemData.remark"
                outlined hide-details
                color="black"
                label="Remark"
                ></v-textarea>
            </v-col>
          </v-row>
    </v-container> 
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      show-select
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="300"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="test_item_skey"
      class="fill-height">
      <template v-slot:header.win_name="{ header }">
          {{ header.text.toUpperCase() }}
      </template>
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{vDataTable.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog.dialogAddEdit" max-width="1000px" eager>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newTestItem()">
                <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
               <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Seq" v-model="vDataTable.editedItem.seq" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field label="Test Item" v-model="vDataTable.editedItem.test_item_id"
                      outlined dense hide-details readonly
                      @click:clear="clearTestItem"
                      clearable>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="blue" @click="browseTestItem">mdi-file-find</v-icon>
                          </template>
                          Search Test Item
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Test Item Description" v-model="vDataTable.editedItem.test_item_desc" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-textarea
                        v-model="vDataTable.editedItem.remark"
                        outlined hide-details
                        color="black"
                        label="Remark"
                  ></v-textarea>
                  </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
                  <v-btn outlined color="primary" @click="save" :disabled="disabledControl.buttonSaveDetail">{{$t('save')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTable.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTable.selected.length}})s</td> 
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import OrderItemBrowse from '@/components/common/OrderItemBrowse'
import TestItemBrowse from '@/components/common/TestItemBrowse'

export default {
  components: {
    OrderItemBrowse,
    TestItemBrowse,
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogBrowseOrderItem: false,
        dialogBrowseTestItem: false,
      },
      stateWindow: '',
      readOnlyControl: {
        textFieldOrderItemID: false,
      },
      disabledControl: {
        buttonNew: false,
        buttonDelete: false,
        buttonSave: false,
        buttonQuery: false,
        buttonFind: false,
        buttonSaveDetail: false,
      },
      menu: {
        menuStartDate: false,
        menuDueDate: false,
        menuCompleteDate: false,
        menuEffectiveStartDate: false,
        menuEffectiveStopDate: false,
      },
      orderItemData: [],
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      sendVar: [],
      progressMessage: '',
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    ...mapState({
      userID: state => `${state.user.profile.user_id}`,
      userFullName: state => `${state.user.profile.user_fullname}`,
    }),
    dateRangeTextRequestDateFromTo () {
      return this.criteria.requestDateFromTo.join(' ~ ')
    },
    dateRangeTextCreatedDateFromTo () {
      return this.criteria.createdDateFromTo.join(' ~ ')
    },
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? 'New Order Test Item' : 'Edit Order Test Item'
    },
    headers () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: 'seq', align: 'left', value: 'seq', class: 'text-xl-left body-1 black--text' },
        { text: 'Test Item_ID', align: 'left', value: 'test_item_id', class: 'text-xl-left body-1 black--text' },
        { text: 'Test Item Desc', width: '200', align: 'left', value: 'test_item_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'remark', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
      ]
    },
    offsetAppBar () {
      return this.getShowAppBar ? this.getAppBarHeight : 0
    }
  },

  watch: {
    'dialog.dialogAddEdit' (val) {
      val || this.close()
    },
    stateWindow: function (after, before) {
      try {
        switch (after) {
          case 'NewState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            this.readOnlyControl.textFieldOrderItemID = false
            this.$refs.textFieldOrderItemID.focus()
            break
          case 'DeleteState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            break
          case 'SaveState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = false
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            break
          case 'QueryState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = true
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            this.readOnlyControl.textFieldOrderItemID = false
            this.$refs.textFieldOrderItemID.focus()
            break
          case 'FindState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = false
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            this.readOnlyControl.textFieldOrderItemID = true
            break
        }
      } catch (e) {
        this.$swal({type: 'error', title: e.message})
      }
    },
  },

  async created () {
    this.stateWindow = 'QueryState'
    await this.retrieveOrderItem('')
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
    },
    getVarReturn (value) {
      switch (value.childSend) {
        case 'OrderItemBrowse':
          this.dialog.dialogBrowseOrderItem = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseOrderItem':
                  this.retrieveOrderItem(value.dataSelected[0]['order_item_id'])
                  this.stateWindow = 'FindState'
                  break
              }
          }
          break
        case 'TestItemBrowse':
          this.dialog.dialogBrowseTestItem = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseTestItem':
                  this.vDataTable.editedItem.order_item_skey = this.orderItemData.order_item_skey
                  this.vDataTable.editedItem.test_item_skey = value.dataSelected[0]['test_item_skey']
                  this.vDataTable.editedItem.test_item_id = value.dataSelected[0]['test_item_id']
                  this.vDataTable.editedItem.test_item_desc = value.dataSelected[0]['test_item_desc']
                  break
              }
          }
          break
      }
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    browseTestItem () {
      if (this.vDataTable.editedIndex === -1) {
        this.dialog.dialogBrowseTestItem = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseTestItem'
        this.$refs.TestItemBrowse.retrieveWpTestItem()
      }
    },
    clearTestItem () {
      this.dialog.dialogAddEdit = false
      this.vDataTable.editedItem.test_item_skey = undefined
      this.vDataTable.editedItem.test_item_id = undefined
      this.vDataTable.editedItem.test_item_desc = undefined
      this.dialog.dialogAddEdit = true
    },
    async newOrderItem () {
      await this.retrieveOrderItem('')
      this.stateWindow = 'NewState'
    },
    async deleteOrderItem () {
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Order Item?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          await this.axios.post(process.env.VUE_APP_API + '/orderItem/deleteOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_skey: this.orderItemData.order_item_skey,
          })
            .then(async response => {
              if (response.data.isSuccess) {
                this.$swal({type: 'success', title: response.data.reasonText})
                await this.retrieveOrderItem('')
                this.stateWindow = 'QueryState'
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
        }
      })
    },
    async saveOrderItem () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/saveOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        order_item: this.orderItemData,
      })
        .then(async response => {
          if (response.data.isSuccess) {
            await this.retrieveOrderItem(response.data.data.order_item_id)
            this.stateWindow = 'SaveState'
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            await this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(async e => {
          await this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async queryOrderItem () {
      await this.retrieveOrderItem('')
      this.stateWindow = 'QueryState'
    },
    async findOrderItem () {
      var orderItemID = this.$refs.textFieldOrderItemID.value
      if (orderItemID === undefined || orderItemID.length === 0) {
        this.dialog.dialogBrowseOrderItem = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseOrderItem'
        this.$refs.OrderItemBrowse.retrieveOrderItem()
      } else {
        await this.retrieveOrderItem(orderItemID)
        if (this.$refs.textFieldOrderItemID.value === undefined || this.$refs.textFieldOrderItemID.value.length === 0) {
          var format = require('string-format')
          await this.$swal({type: 'error', title: format('Not Found Order Item ID ({})', orderItemID)})
        } else {
          this.stateWindow = 'FindState'
        }
      }
    },
    newTestItem () {
      if (this.orderItemData.order_item_skey.length === 0) {
        this.$swal({type: 'error', title: 'กรุณาเลือก Order Item ก่อนจะเพิ่มข้อมูล'})
        this.disabledControl.buttonSaveDetail = true
      } else {
        this.disabledControl.buttonSaveDetail = false
      }
    },
    async retrieveOrderItem (orderItemID) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/orderItem/retrieveOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
        'order_item_id': orderItemID,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.orderItemData = response.data.data[0]
            this.vDataTable.data = this.orderItemData.lis_order_test_item
            this.initialize()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: 'Are you sure you want to delete selected Order Test Item?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: 'Please select Order Test Item to delete'})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        var val = await this.deleteOrderTestItem(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))

      // del.forEach(x => {
      //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      // })

      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
      // this.retrieveWindow(this.appName)
    },
    async deleteOrderTestItem (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var orderItemSkey = item.order_item_skey
        var testItemSkey = item.test_item_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/orderItem/deleteOrderTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
          order_item_skey: orderItemSkey,
          test_item_skey: testItemSkey,
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTable.data.indexOf(item) >= 0) {
                this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEdit = true
    },
    async deleteItemConfirm (item) {
      // this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      // this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Order Test Item?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteOrderTestItem(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(item) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(item), 1)
            }
          }
        }
      })
    },
    close () {
      this.dialog.dialogAddEdit = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedItem.seq === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Seq'})
        return
      }
      if (this.vDataTable.editedItem.test_item_skey === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Test Item'})
        return
      }
      if (this.vDataTable.editedIndex > -1) {
        if (this.vDataTable.editedItem.state_row === 'New') {
        } else {
          this.vDataTable.editedItem.state_row = 'Edit'
        }
        Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
        this.close()
      } else {
        this.vDataTable.editedItem.state_row = 'New'
        this.vDataTable.data.push(this.vDataTable.editedItem)
        this.close()
      }
    }
  },
}
</script>
<style scoped>
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
</style>